import React, { useState } from 'react';
import { TaxCodesList } from './TaxCodesList';
import { TaxCodeForm } from './TaxCodeForm';
import { TaxCodeAuditHistory } from './TaxCodeAuditHistory';
import { BookIcon, ChevronRightIcon, PercentIcon } from 'lucide-react';
export function TaxCodesManagement({
  locale = 'en-US'
}) {
  const [currentView, setCurrentView] = useState('list');
  const [selectedTaxCode, setSelectedTaxCode] = useState(null);
  const [taxCodes, setTaxCodes] = useState([{
    id: 'tax-001',
    code: 'GST10',
    description: 'GST Inclusive',
    rate: 0.1,
    isInclusive: true,
    isExempt: false,
    country: 'AU',
    taxType: 'GST',
    jurisdiction: '',
    currencyCode: 'AUD',
    globalTaxDefinitionId: '',
    activeFrom: '2020-01-01',
    activeTo: null,
    status: 'Active',
    createdAt: '2020-01-01T00:00:00Z',
    createdBy: 'System Admin',
    modifiedAt: '2020-01-01T00:00:00Z',
    modifiedBy: 'System Admin'
  }, {
    id: 'tax-002',
    code: 'VAT20',
    description: 'Standard VAT',
    rate: 0.2,
    isInclusive: false,
    isExempt: false,
    country: 'GB',
    taxType: 'VAT',
    jurisdiction: '',
    currencyCode: 'GBP',
    globalTaxDefinitionId: '',
    activeFrom: '2020-01-01',
    activeTo: null,
    status: 'Active',
    createdAt: '2020-01-01T00:00:00Z',
    createdBy: 'System Admin',
    modifiedAt: '2020-01-01T00:00:00Z',
    modifiedBy: 'System Admin'
  }, {
    id: 'tax-003',
    code: 'VAT5',
    description: 'Reduced VAT',
    rate: 0.05,
    isInclusive: false,
    isExempt: false,
    country: 'GB',
    taxType: 'VAT',
    jurisdiction: '',
    currencyCode: 'GBP',
    globalTaxDefinitionId: '',
    activeFrom: '2020-01-01',
    activeTo: null,
    status: 'Active',
    createdAt: '2020-01-01T00:00:00Z',
    createdBy: 'System Admin',
    modifiedAt: '2020-01-01T00:00:00Z',
    modifiedBy: 'System Admin'
  }, {
    id: 'tax-004',
    code: 'EXEMPT',
    description: 'Tax Exempt',
    rate: 0,
    isInclusive: false,
    isExempt: true,
    country: 'US',
    taxType: 'SalesTax',
    jurisdiction: '',
    currencyCode: 'USD',
    globalTaxDefinitionId: '',
    activeFrom: '2020-01-01',
    activeTo: null,
    status: 'Active',
    createdAt: '2020-01-01T00:00:00Z',
    createdBy: 'System Admin',
    modifiedAt: '2020-01-01T00:00:00Z',
    modifiedBy: 'System Admin'
  }, {
    id: 'tax-005',
    code: 'NY-SALES',
    description: 'New York Sales Tax',
    rate: 0.08875,
    isInclusive: false,
    isExempt: false,
    country: 'US',
    taxType: 'SalesTax',
    jurisdiction: 'New York',
    currencyCode: 'USD',
    globalTaxDefinitionId: '',
    activeFrom: '2020-01-01',
    activeTo: null,
    status: 'Active',
    createdAt: '2020-01-01T00:00:00Z',
    createdBy: 'System Admin',
    modifiedAt: '2021-03-15T00:00:00Z',
    modifiedBy: 'John Smith'
  }, {
    id: 'tax-006',
    code: 'CA-SALES',
    description: 'California Sales Tax',
    rate: 0.0725,
    isInclusive: false,
    isExempt: false,
    country: 'US',
    taxType: 'SalesTax',
    jurisdiction: 'California',
    currencyCode: 'USD',
    globalTaxDefinitionId: '',
    activeFrom: '2020-01-01',
    activeTo: null,
    status: 'Active',
    createdAt: '2020-01-01T00:00:00Z',
    createdBy: 'System Admin',
    modifiedAt: '2021-03-15T00:00:00Z',
    modifiedBy: 'John Smith'
  }, {
    id: 'tax-007',
    code: 'IGST18',
    description: 'Integrated GST 18%',
    rate: 0.18,
    isInclusive: true,
    isExempt: false,
    country: 'IN',
    taxType: 'GST',
    jurisdiction: '',
    currencyCode: 'INR',
    globalTaxDefinitionId: '',
    activeFrom: '2020-01-01',
    activeTo: null,
    status: 'Active',
    createdAt: '2020-01-01T00:00:00Z',
    createdBy: 'System Admin',
    modifiedAt: '2020-01-01T00:00:00Z',
    modifiedBy: 'System Admin'
  }, {
    id: 'tax-008',
    code: 'CGST9',
    description: 'Central GST 9%',
    rate: 0.09,
    isInclusive: true,
    isExempt: false,
    country: 'IN',
    taxType: 'GST',
    jurisdiction: '',
    currencyCode: 'INR',
    globalTaxDefinitionId: '',
    activeFrom: '2020-01-01',
    activeTo: null,
    status: 'Active',
    createdAt: '2020-01-01T00:00:00Z',
    createdBy: 'System Admin',
    modifiedAt: '2020-01-01T00:00:00Z',
    modifiedBy: 'System Admin'
  }, {
    id: 'tax-009',
    code: 'SGST9',
    description: 'State GST 9%',
    rate: 0.09,
    isInclusive: true,
    isExempt: false,
    country: 'IN',
    taxType: 'GST',
    jurisdiction: '',
    currencyCode: 'INR',
    globalTaxDefinitionId: '',
    activeFrom: '2020-01-01',
    activeTo: null,
    status: 'Active',
    createdAt: '2020-01-01T00:00:00Z',
    createdBy: 'System Admin',
    modifiedAt: '2020-01-01T00:00:00Z',
    modifiedBy: 'System Admin'
  }, {
    id: 'tax-010',
    code: 'IVA22',
    description: 'IVA Standard',
    rate: 0.22,
    isInclusive: true,
    isExempt: false,
    country: 'IT',
    taxType: 'VAT',
    jurisdiction: '',
    currencyCode: 'EUR',
    globalTaxDefinitionId: '',
    activeFrom: '2020-01-01',
    activeTo: null,
    status: 'Active',
    createdAt: '2020-01-01T00:00:00Z',
    createdBy: 'System Admin',
    modifiedAt: '2020-01-01T00:00:00Z',
    modifiedBy: 'System Admin'
  }, {
    id: 'tax-011',
    code: 'MWST19',
    description: 'Mehrwertsteuer Standard',
    rate: 0.19,
    isInclusive: true,
    isExempt: false,
    country: 'DE',
    taxType: 'VAT',
    jurisdiction: '',
    currencyCode: 'EUR',
    globalTaxDefinitionId: '',
    activeFrom: '2020-01-01',
    activeTo: null,
    status: 'Active',
    createdAt: '2020-01-01T00:00:00Z',
    createdBy: 'System Admin',
    modifiedAt: '2020-01-01T00:00:00Z',
    modifiedBy: 'System Admin'
  }, {
    id: 'tax-012',
    code: 'MWST7',
    description: 'Mehrwertsteuer Reduced',
    rate: 0.07,
    isInclusive: true,
    isExempt: false,
    country: 'DE',
    taxType: 'VAT',
    jurisdiction: '',
    currencyCode: 'EUR',
    globalTaxDefinitionId: '',
    activeFrom: '2020-01-01',
    activeTo: null,
    status: 'Inactive',
    createdAt: '2020-01-01T00:00:00Z',
    createdBy: 'System Admin',
    modifiedAt: '2022-05-10T00:00:00Z',
    modifiedBy: 'Jane Doe'
  }]);
  const [auditHistory, setAuditHistory] = useState([{
    id: 'audit-001',
    taxCodeId: 'tax-005',
    action: 'Update',
    field: 'rate',
    oldValue: '0.0825',
    newValue: '0.08875',
    timestamp: '2021-03-15T00:00:00Z',
    userId: 'user-001',
    userName: 'John Smith'
  }, {
    id: 'audit-002',
    taxCodeId: 'tax-006',
    action: 'Update',
    field: 'rate',
    oldValue: '0.0725',
    newValue: '0.0725',
    timestamp: '2021-03-15T00:00:00Z',
    userId: 'user-001',
    userName: 'John Smith'
  }, {
    id: 'audit-003',
    taxCodeId: 'tax-012',
    action: 'Update',
    field: 'status',
    oldValue: 'Active',
    newValue: 'Inactive',
    timestamp: '2022-05-10T00:00:00Z',
    userId: 'user-002',
    userName: 'Jane Doe'
  }]);
  const handleAddTaxCode = taxCodeData => {
    const newTaxCode = {
      id: `tax-${String(taxCodes.length + 1).padStart(3, '0')}`,
      ...taxCodeData,
      status: 'Active',
      createdAt: new Date().toISOString(),
      createdBy: 'Current User',
      modifiedAt: new Date().toISOString(),
      modifiedBy: 'Current User'
    };
    setTaxCodes([...taxCodes, newTaxCode]);
    setCurrentView('list');
  };
  const handleUpdateTaxCode = updatedTaxCode => {
    const updatedTaxCodes = taxCodes.map(taxCode => taxCode.id === updatedTaxCode.id ? {
      ...updatedTaxCode,
      modifiedAt: new Date().toISOString(),
      modifiedBy: 'Current User'
    } : taxCode);
    setTaxCodes(updatedTaxCodes);
    // Add to audit history
    const originalTaxCode = taxCodes.find(tc => tc.id === updatedTaxCode.id);
    if (originalTaxCode) {
      const changedFields = Object.keys(updatedTaxCode).filter(key => updatedTaxCode[key] !== originalTaxCode[key] && key !== 'modifiedAt' && key !== 'modifiedBy');
      if (changedFields.length > 0) {
        const newAuditEntries = changedFields.map(field => ({
          id: `audit-${String(auditHistory.length + 1).padStart(3, '0')}`,
          taxCodeId: updatedTaxCode.id,
          action: 'Update',
          field,
          oldValue: String(originalTaxCode[field]),
          newValue: String(updatedTaxCode[field]),
          timestamp: new Date().toISOString(),
          userId: 'user-current',
          userName: 'Current User'
        }));
        setAuditHistory([...auditHistory, ...newAuditEntries]);
      }
    }
    setCurrentView('list');
    setSelectedTaxCode(null);
  };
  const handleToggleStatus = taxCodeId => {
    const updatedTaxCodes = taxCodes.map(taxCode => {
      if (taxCode.id === taxCodeId) {
        const newStatus = taxCode.status === 'Active' ? 'Inactive' : 'Active';
        // Add to audit history
        const newAuditEntry = {
          id: `audit-${String(auditHistory.length + 1).padStart(3, '0')}`,
          taxCodeId: taxCode.id,
          action: 'Update',
          field: 'status',
          oldValue: taxCode.status,
          newValue: newStatus,
          timestamp: new Date().toISOString(),
          userId: 'user-current',
          userName: 'Current User'
        };
        setAuditHistory([...auditHistory, newAuditEntry]);
        return {
          ...taxCode,
          status: newStatus,
          modifiedAt: new Date().toISOString(),
          modifiedBy: 'Current User'
        };
      }
      return taxCode;
    });
    setTaxCodes(updatedTaxCodes);
  };
  const handleViewTaxCode = taxCode => {
    setSelectedTaxCode(taxCode);
    setCurrentView('edit');
  };
  const handleViewAuditHistory = taxCode => {
    setSelectedTaxCode(taxCode);
    setCurrentView('audit');
  };
  const handleBulkDeactivate = criteria => {
    const updatedTaxCodes = taxCodes.map(taxCode => {
      if (criteria.country && taxCode.country === criteria.country || criteria.taxType && taxCode.taxType === criteria.taxType) {
        if (taxCode.status === 'Active') {
          // Add to audit history
          const newAuditEntry = {
            id: `audit-${String(auditHistory.length + 1).padStart(3, '0')}`,
            taxCodeId: taxCode.id,
            action: 'Update',
            field: 'status',
            oldValue: taxCode.status,
            newValue: 'Inactive',
            timestamp: new Date().toISOString(),
            userId: 'user-current',
            userName: 'Current User'
          };
          setAuditHistory([...auditHistory, newAuditEntry]);
          return {
            ...taxCode,
            status: 'Inactive',
            modifiedAt: new Date().toISOString(),
            modifiedBy: 'Current User'
          };
        }
      }
      return taxCode;
    });
    setTaxCodes(updatedTaxCodes);
  };
  const renderContent = () => {
    switch (currentView) {
      case 'list':
        return <TaxCodesList taxCodes={taxCodes} onAddNew={() => {
          setSelectedTaxCode(null);
          setCurrentView('create');
        }} onEdit={handleViewTaxCode} onToggleStatus={handleToggleStatus} onViewAuditHistory={handleViewAuditHistory} onBulkDeactivate={handleBulkDeactivate} locale={locale} data-id="element-9971" />;
      case 'create':
        return <TaxCodeForm onSave={handleAddTaxCode} onCancel={() => setCurrentView('list')} locale={locale} data-id="element-9972" />;
      case 'edit':
        return selectedTaxCode ? <TaxCodeForm taxCode={selectedTaxCode} onSave={handleUpdateTaxCode} onCancel={() => {
          setCurrentView('list');
          setSelectedTaxCode(null);
        }} locale={locale} data-id="element-9973" /> : <div className="text-center py-8" data-id="element-9974">
            <p className="text-gray-500" data-id="element-9975">No tax code selected.</p>
            <button onClick={() => setCurrentView('list')} className="mt-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-9976">
              Back to Tax Codes
            </button>
          </div>;
      case 'audit':
        return selectedTaxCode ? <TaxCodeAuditHistory taxCode={selectedTaxCode} auditEntries={auditHistory.filter(entry => entry.taxCodeId === selectedTaxCode.id)} onBack={() => {
          setCurrentView('list');
          setSelectedTaxCode(null);
        }} locale={locale} data-id="element-9977" /> : <div className="text-center py-8" data-id="element-9978">
            <p className="text-gray-500" data-id="element-9979">No tax code selected.</p>
            <button onClick={() => setCurrentView('list')} className="mt-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-9980">
              Back to Tax Codes
            </button>
          </div>;
      default:
        return <div className="text-center py-8" data-id="element-9981">
            <p className="text-gray-500" data-id="element-9982">Unknown view.</p>
            <button onClick={() => setCurrentView('list')} className="mt-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-9983">
              Back to Tax Codes
            </button>
          </div>;
    }
  };
  return <div data-id="element-9984">
      <div className="mb-8" data-id="element-9985">
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-9986">
          Tax Codes Management
        </h2>
        <p className="mt-1 text-sm text-gray-500" data-id="element-9987">
          Manage tax codes for different countries, jurisdictions, and use cases
        </p>
      </div>
      {/* Breadcrumbs */}
      <nav className="flex mb-6" aria-label="Breadcrumb" data-id="element-9988">
        <ol className="inline-flex items-center space-x-1 md:space-x-3" data-id="element-9989">
          <li className="inline-flex items-center" data-id="element-9990">
            <button onClick={() => setCurrentView('list')} className="inline-flex items-center text-sm font-medium text-indigo-600 hover:text-indigo-800" data-id="element-9991">
              <BookIcon className="w-4 h-4 mr-2" data-id="element-9992" />
              Financial
            </button>
          </li>
          <li data-id="element-9993">
            <div className="flex items-center" data-id="element-9994">
              <ChevronRightIcon className="w-4 h-4 text-gray-400 mx-1" data-id="element-9995" />
              <button onClick={() => setCurrentView('list')} className="inline-flex items-center text-sm font-medium text-indigo-600 hover:text-indigo-800" data-id="element-9996">
                <PercentIcon className="w-4 h-4 mr-2" data-id="element-9997" />
                Tax Codes
              </button>
            </div>
          </li>
          {currentView === 'create' && <li data-id="element-9998">
              <div className="flex items-center" data-id="element-9999">
                <ChevronRightIcon className="w-4 h-4 text-gray-400 mx-1" data-id="element-10000" />
                <span className="text-sm font-medium text-gray-500" data-id="element-10001">
                  Create New
                </span>
              </div>
            </li>}
          {currentView === 'edit' && selectedTaxCode && <li data-id="element-10002">
              <div className="flex items-center" data-id="element-10003">
                <ChevronRightIcon className="w-4 h-4 text-gray-400 mx-1" data-id="element-10004" />
                <span className="text-sm font-medium text-gray-500" data-id="element-10005">
                  Edit {selectedTaxCode.code}
                </span>
              </div>
            </li>}
          {currentView === 'audit' && selectedTaxCode && <li data-id="element-10006">
              <div className="flex items-center" data-id="element-10007">
                <ChevronRightIcon className="w-4 h-4 text-gray-400 mx-1" data-id="element-10008" />
                <span className="text-sm font-medium text-gray-500" data-id="element-10009">
                  Audit History - {selectedTaxCode.code}
                </span>
              </div>
            </li>}
        </ol>
      </nav>
      {renderContent()}
    </div>;
}